import React from "react";
import { FeaturePageShell } from "./FeaturePageShell";
import footImage from "./assets/ai-proposal/foot.png";
import hotelImage from "./assets/ai-proposal/hotel.png";
import realEstateImage from "./assets/ai-proposal/realestate.jpg";
import weddingImage from "./assets/ai-proposal/mariage.png";
import generatedProposalImage from "./assets/ai-engeeningr/aiProposal.png";

const contexts = [
  ["Sport", footImage],
  ["Hospitality", hotelImage],
  ["Wedding", weddingImage],
  ["Real estate", realEstateImage],
];

export default function AIProposalPage() {
  return (
    <FeaturePageShell
      pageTitle="AI Proposal"
      currentPath="/use-cases/ai-proposal"
      eyebrow="WEAVEVO AI ENGINE · SMART SUGGESTIONS"
      heroTitle="AI sparks the story before production even starts."
      heroText="The AI Suggests feed cross-references interests, exact geolocation, emerging web trends and the internal asset library to turn scattered signals into structured Living Media concepts on demand."
      heroImage={weddingImage}
      heroAlt="Weavevo AI Suggests generating a wedding Living Weave from contextual signals"
      finalEyebrow="FROM SIGNAL TO LIVING WEAVE"
      finalTitle="Move from an idea to a structured, contributor-ready story in one flow."
      finalText="Preview the AI proposal, launch the living stream on its permanent root URL and let the collaboration continue as existing media and new Weaver contributions arrive."
    >
      <section className="fp-section">
        <figure style={{ margin: 0, overflow: "hidden", borderRadius: 18, border: "1px solid #dfe6ef", boxShadow: "0 24px 64px rgba(24,40,76,.14)" }}>
          <img src={generatedProposalImage} alt="AI proposal orchestration" loading="lazy" style={{ display: "block", width: "100%", height: "auto" }} />
        </figure>
      </section>

      <section className="fp-section">
        <div className="fp-sectionHead">
          <span className="fp-sectionEyebrow">CONTEXT-DRIVEN IDEATION</span>
          <h2>One creative engine. Different worlds, different story signals.</h2>
          <p>Ideas adapt to where you are, what is trending and what the audience cares about, turning live local and cultural context into actionable video concepts.</p>
        </div>
        <div className="fp-aiMosaic">
          {contexts.map(([label, image]) => (
            <figure className="fp-aiTile" key={label}>
              <img src={image} alt={`${label} AI proposal example`} loading="lazy" />
              <span>{label}</span>
            </figure>
          ))}
        </div>
      </section>

      <section className="fp-section">
        <div className="fp-sectionHead">
          <span className="fp-sectionEyebrow">MATCH BEFORE YOU SHOOT</span>
          <h2>Reuse what already exists. Request only what is missing.</h2>
        </div>
        <div className="fp-twoCol">
          <article className="fp-card">
            <span className="fp-cardLabel">Instant media matching</span>
            <h3>Archive and community footage slots itself into the story arc.</h3>
            <p>When suitable footage already exists in your archives or the community pool, the AI identifies, pairs, formats and slots it directly into the proposed Weave.</p>
          </article>
          <article className="fp-card">
            <span className="fp-cardLabel">Targeted Weaver notifications</span>
            <h3>Fresh perspectives are requested from the right people.</h3>
            <p>When a concept needs new on-the-ground footage, qualified nearby Weavers receive clear slot briefs for the missing angles.</p>
          </article>
        </div>
      </section>

      <section className="fp-section">
        <div className="fp-sectionHead">
          <span className="fp-sectionEyebrow">WEAVEVO AI HARMONIZATION</span>
          <h2>From mixed sources to one coherent Living Weave.</h2>
        </div>
        <div className="fp-aiPipeline">
          <article className="fp-card"><span className="fp-stepNo">01 · DISCOVER</span><h3>Context-driven concept</h3><p>Interests, location, trends and internal knowledge shape the proposed narrative.</p></article>
          <article className="fp-card"><span className="fp-stepNo">02 · MATCH</span><h3>Existing media first</h3><p>Relevant footage is located and assigned to the right slots before new capture is requested.</p></article>
          <article className="fp-card"><span className="fp-stepNo">03 · HARMONIZE</span><h3>Color, audio and subtitles</h3><p>Archived master cuts and live smartphone captures are balanced, acoustically aligned and enriched with multilingual subtitles.</p></article>
          <article className="fp-card"><span className="fp-stepNo">04 · APPROVE</span><h3>Launch + Smart Escrow</h3><p>Approve the creative proposal, publish the permanent living stream and split contributor royalties through Smart Escrow.</p></article>
        </div>
      </section>
    </FeaturePageShell>
  );
}
